// extracted by mini-css-extract-plugin
module.exports = {"garellyLogin":"styles_garellyLogin__2PPp2","feedback":"styles_feedback__lr39R"};